import { connect } from 'react-redux';
import React, { Component } from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';

import { dmarcEffectivenessIsLoadingSelector } from '../../selectors/dmarc-effectiveness-selectors';
import { fetchDmarcEffectivenessIfNeeded } from '../../actions/dmarc-effectiveness-action-creators';
import { getAdjustedEndDate } from '../../../utils/report-utils';
import {
    reportHeaderSelector,
    selectedDateOptionSelector,
    selectedDomainSelector,
    selectedEndDateSelector,
    selectedIntervalSelector,
    selectedStartDateSelector
} from '../../selectors/reports-selectors';
import DmarcEffectivenessProgressBulletsContainer from
    './dmarc-effectiveness-progress-bullets-container';
import DmarcEffectivenessTableContainer from
    './dmarc-effectiveness-table-container';
import DmarcEffectivenessVisContainer from
    './dmarc-effectiveness-vis-container';
import ReportingCard from '../../components/reporting-card';

export class DmarcEffectivenessSectionContainer extends Component{
    constructor( props ){
        super( props );
        const { selectedStartDate, selectedEndDate, selectedInterval, onInitialLoad } = this.props;
        const params = {
            endDate: selectedEndDate,
            interval: selectedInterval,
            startDate: selectedStartDate,
        };

        onInitialLoad();
        this.fetchData( params );
    };

    componentDidUpdate( prevProps ){
        const { selectedStartDate, selectedEndDate, selectedInterval, selectedDomain, selectedDateRange } = this.props;
        if( _.isEqual( selectedStartDate, prevProps.selectedStartDate ) ||
            _.isEqual(  selectedEndDate, prevProps.selectedEndDate ) ||
            _.isEqual( selectedInterval, prevProps.selectedInterval ) ||
            _.isEqual( selectedDomain, prevProps.selectedDomain ) ){
            const endDate = getAdjustedEndDate( selectedDateRange, selectedInterval, selectedEndDate );
            const params = {
                endDate: endDate,
                interval: selectedInterval,
                startDate: selectedStartDate,
            };
            this.fetchData( params );
        };
    };

    fetchData = ( params ) => {
        const { selectedDomain, fetchDmarcEffectivenessIfNeeded } = this.props;
        if( selectedDomain && params ){
            params.domain = selectedDomain;
        };

        fetchDmarcEffectivenessIfNeeded( params );
    };

    render(){
        const { dmarcEffectivenessDataIsLoading, header } = this.props;

        return (
            <ReportingCard
                header={ header }
                dataIsLoading={ dmarcEffectivenessDataIsLoading }
                type={ 'effectiveness' }
                allowDownload={ true }
                order={ 2 }
                content={{
                    leftContent: <DmarcEffectivenessProgressBulletsContainer />,
                    legend: {
                        dotLabel: 'Unauthorized Email DMARC Block Rate (%)',
                        streamLabel: 'Unauthorized Email Volume'
                    },
                    rightContent: <DmarcEffectivenessVisContainer
                        isLoading={ dmarcEffectivenessDataIsLoading }
                    />,
                    subtitle: 'Emails sent to consumer mailbox providers',
                    table: <DmarcEffectivenessTableContainer />,
                    textheader: 'How well did unauthorized email to consumer mailbox providers get blocked via (DMARC) blocking* policies?',
                    title: 'Unauthorized Email DMARC Block Rate',
                }}
            />
        );
    };
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        dmarcEffectivenessDataIsLoading: dmarcEffectivenessIsLoadingSelector( state ),
        header: reportHeaderSelector( state ),
        selectedDateRange: selectedDateOptionSelector( state ),
        selectedDomain: selectedDomainSelector( state ),
        selectedEndDate: selectedEndDateSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
        selectedStartDate: selectedStartDateSelector( state ),
    };
};

DmarcEffectivenessSectionContainer.propTypes = {
    dmarcEffectivenessDataIsLoading: PropTypes.bool.isRequired,
    fetchDmarcEffectivenessIfNeeded: PropTypes.func.isRequired,
    header: PropTypes.object.isRequired,
    onInitialLoad: PropTypes.func.isRequired,
    selectedDateRange: PropTypes.string,
    selectedDomain: PropTypes.string,
    selectedEndDate: PropTypes.string.isRequired,
    selectedInterval: PropTypes.string,
    selectedStartDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, { fetchDmarcEffectivenessIfNeeded } )( DmarcEffectivenessSectionContainer );
